import React, { useState, useEffect } from 'react';
import { Redirect, Link} from 'react-router-dom';
import withSizes from 'react-sizes';
import { Capacitor } from '@capacitor/core';

import auth from '../services/auth';
import fetcher from '../services/fetcher'
import log from '../services/log'
import seo from '../services/seo'

import Layout from './_Layout';
import AppleSignInButton from '../components/buttons/AppleSignInButton';
import Uvp from '../components/Uvp';
import UvpMobile from '../components/UvpMobile';
import SignInAndPWAButtons from '../components/SignInAndPWAButtons';
import MobileInstallButtons from '../components/MobileInstallButtons';
import MovingAlertsList from '../components/MovingAlertsList';
import Heatmap from '../components/Heatmap';
import MouseScroll from '../components/MouseScroll'
import Footer from '../components/Footer';
import CoinChip from '../components/CoinChip';
import Spinner from '../components/Spinner';
import LandingCta from '../components/landing/LandingCta';
import LandingFeatureCard from '../components/landing/LandingFeatureCard';

import useIndicators from '../hooks/useIndicators';

import '../css/landing.css'
import JoinReferralButton from '../components/buttons/JoinReferralButton';

function Landing(props){
  const [indicators, isIndicatorsLoading] = useIndicators()
  const [coins, setCoins] = useState(null)
  const [alerts, setAlerts] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  async function getCoins(){
    setIsLoading(true)
    const rsiData = await fetcher.getRSI()
    //log.traceTag('rsi', rsiData)
    if (rsiData){
        setIsLoading(false)
        setCoins(rsiData.filter(x => x.rsi != null))
    }
  }

 async function getAlerts(){
    setIsLoading(true)
    const latestAlerts = await fetcher.getSignals()
    log.traceTag('alerts', alerts)
    if (latestAlerts && coins){
        setIsLoading(false)
        const filteredAlerts = latestAlerts.filter(a => coins.map(c => c.coin).includes(a.coin))
        log.traceTag('filteredAlerts', filteredAlerts);
        setAlerts(filteredAlerts)
        //log.trace(alerts);
    }
  }

  useEffect(() => {
    getAlerts();
  }, [coins]);

  useEffect(() => {
    getCoins()
  }, []);

  log.trace(process.env.NODE_ENV)

  if (auth.isLogged()) {
    return <Redirect to={{
      pathname: '/dashboard'
    }}/>;
  }

  return (
    <Layout>
    <div className={Capacitor.isNativePlatform() ? '' : 'mx-auto w-full'}>
      {Capacitor.isNativePlatform() &&
        <>
          <UvpMobile>
          </UvpMobile>
        </>
      }
      {!Capacitor.isNativePlatform() &&
      <div className="relative">
        <div className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-slate-50 via-white to-slate-100" />
        {seo.landing()}
        <Uvp
          showScreenshots={false}
          showLogInButton={true}
          coins={coins}
          alerts={alerts ? alerts.slice(0, 10) : null}
        >
        </Uvp>

        <section className="py-10 md:py-14">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              Real-Time Crypto <span className='hl-silver'>RSI Heatmap (4h/1D)</span>
            </h2>
            <p className={`mt-3 mb-6 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`} style={{lineHeight: 1.7+'em'}}>
              Watch live crypto market price moves and RSI signals from coin to coin using unique and original RSI Crypto Market Heatmap.
            </p>
            {indicators && coins && alerts && !isLoading &&
              <Heatmap showToggle={false} indicators={indicators} landing={true} coins={coins} portfolio={[]} alerts={alerts} onCoinSelected={(coinSymbol) => {
              }}></Heatmap>
            }
            {isLoading &&
              <div className="text-center mb-2">
                <Spinner small={false}></Spinner>
              </div>
            }
          </div>
        </section>

         <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Join <span style={{fontWeight: 300}}>Crypto</span>Waves Now
            </>
          )}
        />

        <div className="my-10"><MouseScroll></MouseScroll></div>

        <section className="py-12 md:py-16">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              One RSI Tracker. <span className='hl-silver'>Android. iOS. Web.</span>
            </h2>
            <p className={`my-3 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`} style={{lineHeight: 1.7+'em'}}>
              CryptoWaves.app helps you track the crypto market on any device. Sign up once and use it on Android, iOS, or Web.
            </p>
            <div className="mt-6 flex flex-col items-center gap-4">
              <SignInAndPWAButtons align="center" isMobile={props.isMobile}>
                &nbsp;&nbsp;Sign In To Web
              </SignInAndPWAButtons>
              <MobileInstallButtons isMobile={props.isMobile} />
            </div>
          </div>
        </section>

        <div className="my-10"><MouseScroll></MouseScroll></div>

        <section className="py-12 md:py-16">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              Real-Time <span className="hl-silver">RSI Alerts</span> For 150 Crypto Coins
            </h2>
            <p className={`my-3 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`} style={{lineHeight: 1.7+'em'}}>
              CryptoWaves.app scans crypto market in real time and sends you personalized crypto RSI signals straight to your Email, Telegram & Mobile so you never miss the crypto price dips and spikes even for altcoins you do not yet track.
            </p>
            {coins && alerts && !isLoading &&
              <MovingAlertsList
                landing={true}
                coins={coins}
                alerts={alerts.slice(0, 10)}
                visibleCount={3}
                itemHeight={120}
                durationMs={24000}
                onCoinSelected={(coinSymbol) => {
                }}
              ></MovingAlertsList>
            }
          </div>
        </section>

        <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Get <span style={{fontWeight: 300}}>RSI Alerts</span> On Your Email <span className="hide-small">& Telegram</span>
            </>
          )}
        />

        <MouseScroll></MouseScroll>

        <section className="py-12 md:py-16">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              Crypto Relative Strength Index Alerts, <span className="hl-silver">History & Charts</span>
            </h2>
            <h3 className={`my-3 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`}  style={{lineHeight: 1.7+'em'}}>
              CryptoWaves.app keep, track and process RSI alerts & signals for more than 150 coins in real-time and  help you to get buy/sell recommendation based on recent price moves and volumes so you can capture more return on your investment.
            </h3>
            {coins && alerts && !isLoading &&
              <>
                {coins.slice(0, 50).map(coin => <CoinChip key={coin.coin} coin={coin} onClick={(symbol) => {
                  window.location.href=`/relative-strength-index/${seo.toSlug(symbol)}`
                }}></CoinChip>)}
              </>
            }
            <Link className="text-sm text-gray-500 hover:text-gray-700">And more...</Link>
          </div>
        </section>

        <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Get Crypto <span style={{fontWeight: 300}}> Market </span> Insight
            </>
          )}
        />

        <MouseScroll></MouseScroll>

        <section className="py-12 md:py-16">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="my-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-3xl md:text-3xl">
              Reduce Noise. Get <span className="hl-silver">Details That Matter</span> Most.
            </h2>
            <h3 className={`my-3 text-base text-gray-500 sm:text-lg md:text-lg ${!props.isMobile ? 'mx-5 px-5' :''}`}  style={{lineHeight: 1.7+'em'}}>
              We rely on crypto data you can trust and already use everyday but finally refined and tailored to help you portfolio grow. All in one advanced mobile-first relative strength index (RSI) crypto signals & notifications application.
            </h3>
            <div className="mt-10 grid gap-6 text-left md:grid-cols-3">
              <LandingFeatureCard
                imageSrc="https://uploads-ssl.webflow.com/609c8e1609b0ae1804a60dad/60b6db3448362f2480d7e744_tradingview.png"
                title="TradingView Charts & RSI Signals"
                description="Get easy access to TradingView Charts & RSI Signals from CryptoWaves RSI HeatMap"
              />
              <LandingFeatureCard
                imageSrc="https://uploads-ssl.webflow.com/609c8e1609b0ae1804a60dad/60b6d5d82ca92072bb7cd24d_coinmarketcap.png"
                title="Track Coin Ranks and Performance"
                description="Stop wasting your time switching between different apps tracking your crypto portfolio"
              />
              <LandingFeatureCard
                imageSrc="https://uploads-ssl.webflow.com/609c8e1609b0ae1804a60dad/60b6d547e665aa54d6bd9a7c_coingecko.png"
                title="Unlock Unique RSI Alerts"
                description="Act quickly when opportunity arise. Get Telegram and Email RSI Alert notifications to stay ahead of the crowd."
              />
            </div>
          </div>
        </section>

        <LandingCta
          isMobile={props.isMobile}
          buttonContent={(
            <>
              &nbsp;&nbsp;Join <span style={{fontWeight: 300}}>Crypto</span>Waves Now
            </>
          )}
        />

        <Footer></Footer>
      </div>
      }
    </div>
    </Layout>
  );
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(Landing);
